import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WebtrekkConfigService } from 'src/app/webtrekk-config.service';

@Injectable({ providedIn: 'root' })
export class searchWebtrekkTrackingService {
    constructor(@Inject(PLATFORM_ID) private platformId: Object,
        private webtrekk: WebtrekkConfigService) { }

    trackAction(searchTerm: string) {
        if (!isPlatformBrowser(this.platformId)) {
            return; // SSR-safe
        }

        this.webtrekk.runWhenReady(() => {
            (window as any).wtSmart?.page?.data?.set('Search', {
                url: window.location.href,
                search: searchTerm.trim(),
            });
            (window as any).wtSmart?.track();
        })
    }
}
